import { isFunction } from 'lodash-es';
const STORAGE_KEY = 'gameBadge';
export const VALIDITY_PERIOD = 1000 * 60 * 60 * 24 * 30;

export function getGameBadgeStorage() {
  const { hasClick = false, createTime } = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');

  return {
    hasClick,
    createTime,
  };
}

export function setGameBadgeStorage(hasClickStatus) {
  const { hasClick, createTime } = getGameBadgeStorage();
  if (hasClick) {
    return;
  }
  let time = createTime;
  if (!time) {
    time = new Date().getTime();
  }

  window.localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      hasClick: hasClickStatus,
      createTime: time,
    }),
  );
}

export function checkGameBadgeValidity() {
  const { hasClick, createTime } = getGameBadgeStorage();
  if (!createTime) {
    return true;
  }

  if (hasClick) {
    return false;
  }
  const currentTime = new Date().getTime();

  return currentTime - createTime > 0 && currentTime - createTime < VALIDITY_PERIOD;
}
/**
 * 递归树形数据，对每项进行处理
 */
export function loopTree(list, handler, targetObj = {}) {
  list.forEach(item => {
    if (isFunction(handler)) {
      handler(targetObj, item);
    }
    if (item.children?.length) {
      loopTree(item.children, handler, targetObj);
    }
  });

  return targetObj;
}
/**
 * 获取 id 对应 item 的 object
 */
export function getIdItemMap(list, id = 'id') {
  return loopTree(list, (obj, item) => {
    obj[item[id]] = item;
  });
}

export const getTagId = id => id.split('-')[1];
export const getTagScene = id => Number(id.split('-')[0]);
export const generateId = (scene, tagId) => `${scene.toString()}-${tagId}`;
export const formatHashtagLabel = name => (name?.startsWith('#') ? name : `#${name}`);
